// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1_AnQ","header":"PatientBlock_header__1Cq_C","label":"PatientBlock_label__1An8E","option":"PatientBlock_option__3gTo3"};